<template>
  <div>
    <top-message />
    <div class="content">
      <div class="top">
        已申请特色产品企业
      </div>
      <div class="from">
        <el-form
          ref="form"
          :model="form"
          label-width="80px"
          :inline="true"
        >
          <el-form-item label="企业名称">
            <el-input
              @change="search"
              v-model="form.deptName"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="统一代码">
            <el-input
              v-model="form.appDeptId "
              @change="search"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="银行名称">
            <el-select
              v-model="form.bankCode"
              clearable
              @change="search"
            >
              <el-option
                v-for="item in applyBankList"
                :key="item.value"
                :label="item.bankName"
                :value="item.bankId"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="产品名称">
            <el-input
              v-model="form.product"
              @change="search"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="申请时间">
            <el-date-picker
              v-model="form.value1"
              @change="time"
              type="daterange"
              range-separator="至"
              start-placeholder="开始月份"
              value-format="yyyy-MM-dd"
              end-placeholder="结束月份"
            >
            </el-date-picker>
          </el-form-item>
        </el-form>
      </div>
      <div class="dowm">
        <el-button
          icon="el-icon-upload2"
          @click="expertExcel"
        >导出统计表</el-button>
      </div>
      <div class="tab">
        <el-table
          :data="applyProList"
          style="width: 100%"
        >
          <el-table-column
            prop="appDeptId"
            label="企业名称/统一代码"
            width="250"
          >
            <template slot-scope="scope">
              <div>
                <div> {{scope.row.enterpriseName}}
                </div>
                <div> {{scope.row.appDeptId}}</div>
              </div>

            </template>
          </el-table-column>
          <el-table-column
            prop="bankName"
            label="银行名称 "
            width="180"
          >
          </el-table-column>
          <el-table-column
            prop="name"
            label="产品名称"
          >
          </el-table-column>
          <el-table-column
            prop="appLimit"
            label="申请金额"
          >
            <template slot-scope="scope">
              {{scope.row.appLimit}}万
            </template>
          </el-table-column>
          <el-table-column
            prop="createTime"
            label="申请时间"
          >
          </el-table-column>
          <el-table-column
            prop="legalPersonPhone"
            label="联系方式"
          >
          </el-table-column>
        </el-table>
        <div class="block">
          <el-pagination
            @current-change="handleCurrentChange"
            :page-size="this.form.pageSize"
            layout="total, prev, pager, next"
            :total='this.total'
          >
          </el-pagination>
        </div>
      </div>

    </div>
  </div>
</template>
<script>
import TopMessage from "@/components/TopMessage";
import { applyProList, applyBankList } from "@/api/statistics";


export default {
  components: { TopMessage },
  data () {
    return {
      form: {
        deptName: '',
        appDeptId: '',
        bankCode: '',
        startTime: '',
        endTime: '',
        value1: '',
        page: 1,
        pageSize: 10,
        product: ''
      },
      applyBankList: [],
      applyProList: [],
      total: 0
    }
  },
  created () {
    this.getApplyProList()
    this.getapplyBankList()
  },
  methods: {
    search () {
      this.getApplyProList()
    },
    getapplyBankList () {
      let params = {}
      applyBankList(this.sendParam(params)).then(res => {
        res = this.paramDecrypt(res)
        console.log(res);
        if (res.code == 200) {
          this.applyBankList = res.data
        }
      })
    },
    time () {
      console.log(this.form);
      if (this.form.value1 !== null) {
        this.form.startTime = this.form.value1[0]
        this.form.endTime = this.form.value1[1]
        this.getApplyProList()
      } else if (this.form.value1 == null) {
        this.form.startTime = ''
        this.form.endTime = ''
        this.getApplyProList()
      }

    },
    getApplyProList () {
      const params = {
        deptName: this.form.deptName,
        appDeptId: this.form.appDeptId,
        bankCode: this.form.bankCode,
        startTime: this.form.startTime,
        endTime: this.form.endTime,
        pageSize: this.form.pageSize,
        page: this.form.page,
        proName: this.form.product
      }
      console.log(params);
      applyProList(this.sendParam(params)).then(res => {
        res = this.paramDecrypt(res)
        console.log(res);
        if (res.code == 200) {
          this.applyProList = res.data.list
          this.total = res.data.total 
        }

      }).catch(error => { })
    },
    handleCurrentChange (val) {
      this.form.page = val
      this.getApplyProList()
    },
    expertExcel () {
      // if (this.form.applyTime[0] == undefined) {
      //   this.form.applyTime[0] = ''
      // }
      // if (this.form.applyTime[1] == undefined) {
      //   this.form.applyTime[1] = ''
      // }
      const xhr = new XMLHttpRequest();
      xhr.open("post", this.baseUrl + "/api/credit/excel/expertApplyProList", true);  // get、post都可
      xhr.responseType = "blob";  // 转换流
      xhr.setRequestHeader("token", sessionStorage.getItem("token")); // token键值对
      xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded")
      xhr.onload = function () {
        if (this.status === 200) {
          const blob = this.response;
          const fileName = "已申请特色产品企业统计表.xls";
          if (window.navigator.msSaveOrOpenBlob) {
            navigator.msSaveBlob(blob, fileName);
          } else {
            const a = document.createElement("a")
            const url = window.URL.createObjectURL(blob);
            a.href = url;
            a.download = fileName;
            document.body.appendChild(a);
            a.click()
            window.URL.revokeObjectURL(url)
          }
        }
      }
      xhr.send("deptName=" + this.form.deptName + "&appDeptId=" + this.form.appDeptId + '&bankCode=' + this.form.bankCode + "&startTime=" + this.form.startTime + "&endTime=" + this.form.endTime + "&pageSize=" + this.form.pageSize +
        "&page=" + this.form.page + "&proName=" + this.form.product);
    }
  }
}
</script>
<style lang='less' scoped>
.content {
  min-height: 894px;
  margin-top: 10px;
  background-color: #fff;
  border-radius: 8px;
  padding-top: 10px;
  padding-bottom: 20px;
  .top {
    height: 30px;
    border-left: 8px solid #2981ee;
    padding-left: 38px;
    box-sizing: border-box;
    font-size: 22px;
    font-family: Alibaba PuHuiTi;
    font-weight: 500;
    color: #2981ee;
    line-height: 30px;
  }
  .from {
    margin-top: 37px;
    margin-left: 38px;
  }
  .dowm {
    width: 100%;
    display: flex;
    justify-content: flex-end;
    padding-right: 40px;
    box-sizing: border-box;
    /deep/ .el-button {
      width: 157px;
      height: 40px;
      background: #2981ee;
      border-radius: 6px;
      color: #fff;
    }
  }
  .tab {
    box-sizing: border-box;
    margin-top: 15px;
    min-height: 700px;
    .block {
      margin-top: 20px;
      display: flex;
      justify-content: center;
    }
    /deep/ .el-table th {
      background: #f3f4f9;
    }
  }
}
</style> 